// const API_URL = "http://localhost:3005"
const API_URL = "https://server.ibis.womi.ma"

export default API_URL
